import { eventsAppUrl } from '@dashboard/services/env';

/**
 * Build a fully-qualified URL into the events app (check-in app /
 * scanner) for a given event page. Centralises the
 * `${eventsAppUrl}/event/${pageId}/...` pattern that previously lived
 * inline in PageOverview, PageEdit, PageTest, and ShareActionCards.
 *
 * @example
 *   getEventsAppUrl(page._id) // scanner home
 *   getEventsAppUrl(page._id, 'guest-list')
 *   getEventsAppUrl(page._id, 'guest-list', { livemode: false })
 */
export default function getEventsAppUrl(
  pageId: string,
  path: string = '',
  query?: Record<string, string | number | boolean | undefined>,
): string {
  const cleanPath = path ? `/${path.replace(/^\/+/, '')}` : '';
  const qs = query
    ? Object.entries(query)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
        .join('&')
    : '';
  return `${eventsAppUrl}/event/${pageId}${cleanPath}${qs ? `?${qs}` : ''}`;
}
